import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import useFirebase from "../../../../useFirebase";
import Select from "react-select";
import useBatteryPercentage from "../../../customHooks/batteryPercentageProvider";
import { setRuleDataSetUp } from "../../AxiosRtk/SetRules";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";

const KidDeviceList = () => {
  const { selectedKidId, kidList, kidDevicesList, selectedDeviceData } = useSelector(({ dashboard }) => dashboard);
  const [deviceStatus, setDeviceStatus] = useState(-1);

  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );

  const [deviceOptions, setDeviceOptions] = useState([]);
  const { handleDeviceSelection } = useDashboardDataProvider();
  const { getLangTranslation } = useLangTranslation();
  const [batteryPercentage, setBatteryPercentage] = useState(0);
  const { getBatteryPercentageData } = useBatteryPercentage(setBatteryPercentage);
  const dispatch = useDispatch();

  const { getCollectionData } = useFirebase();

  useEffect(() => {
    if (selectedDeviceData) {
      getBatteryPercentageData(selectedDeviceData?.ID);
      getCollectionData(selectedDeviceData?.ID);
    } else {
      setBatteryPercentage(0);
      dispatch(setRuleDataSetUp(null));
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (kidDevicesList.length > 0) {
      setDeviceOptions(
        kidDevicesList?.map((item) => {
          return { value: item?.ID, label: item?.Name };
        })
      );
      // handleDeviceSelection({ value: kidDevicesList[0]?.ID });
    }
  }, [kidDevicesList]);

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;

  return (
    <div className="list-item">
      <div className="mb-6">
        <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
          <label
            htmlFor="kid_device"
            className="form-label text-uppercase mb-0"
          >
            {getLangTranslation("CHILD_DETAILS_SELECT_DEVICE", "Select Device")}
          </label>
          <span className="d-inline-flex align-items-center gap-2">
            {/* {`${!batteryPercentage ? 0 : batteryPercentage}%`}{" "} */}
            {`${selectedKidId ? batteryPercentage || 0 : 0}%`}{" "}

            <i className="icon-battery-charging fs-5" />
          </span>
        </div>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap gap-3">
          <div className="select-with-icon">
            <span className="icon-wrap icon-blue pt-cursor border-0">
              <i className="icon-mobile fs-5" />
            </span>
            <Select
              className="custom-select custom-select-top"
              classNamePrefix="custom-select"
              placeholder={getLangTranslation("CHILD_DETAILS_SELECT_DEVICE", "Select Device")}
              options={deviceOptions}
              value={
                deviceOptions?.find((item) => item?.value === selectedDeviceData?.ID) || ""
              }
              onChange={handleDeviceSelection}
              isSearchable={false}
              styles={{
                placeholder: (base) => ({
                  ...base,
                  marginBottom: '12px', // Adjust this value as needed
                }),
              }}
            />

            {deviceStatus === 0 && (
              <span className="text-small text-danger select-custom-text">
                {getLangTranslation(
                  "CHILD_LOCATION_OFFLINE_DEVICE",
                  "Offline Device"
                )}
              </span>
            )}
            {deviceStatus === 1 && (
              <span className="text-small text-success select-custom-text">
                {getLangTranslation(
                  "CHILD_LOCATION_ACTIVE_DEVICE",
                  "Active device"
                )}
              </span>
            )}
          </div>
          {selectedDeviceData?.accessiblityPermission === 1 ? (
            <button
              type="button"
              className="btn border-2 border-success btn-outline-light text-blue-800 text-nowrap fs-8 text-capitalize"
            >
              <span className="text-dark">{`${getLangTranslation(
                "PERMISSIONS_ACCESSIBILITY",
                "Accessibility"
              )} ${getLangTranslation(
                "PERMISSIONS_ENABLED",
                "Enabled!"
              )}`}</span>
            </button>
          ) : (
            <button
              type="button"
              className="btn border-2 border-danger btn-outline-light text-blue-800 text-nowrap fs-8 text-capitalize"
            >
              <span className="text-dark">
                {getLangTranslation(
                  "CHILD_DETAILS_ACCESSIBILITY_DISABLED",
                  "Accessibility disabled!"
                )}
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default KidDeviceList;
